module.exports = __webpack_public_path__ + "fonts/Nunito-LightItalic.25df638.ttf";